module.exports = __webpack_public_path__ + "static/vmware_12.0d7186ea.jpg";